import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a073ec3f6558f00148401c8/tradewithkrish/src/app/sign-up-login-screen/components/AuthPageClient.tsx");
